import { Component, OnInit } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { Router } from '@angular/router';
import { CodaltComponent } from 'app/codalt.component';
import { PageTitleService } from 'app/services/page-title/page-title.service';
import { ConfirmDialogService } from '../services/confirm-dialog-service/confirm-dialog.service';
import { UserService } from '../services/user/user.service';
import { User } from '../user.interface';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    standalone: false,
})
export class RegisterComponent extends CodaltComponent implements OnInit {
    user: User;

    emailInUse = false;
    emailInUseFor: string | null = null;

    submitDisabled = false;
    submitText = 'Registreren';

    constructor(
        private userService: UserService,
        private router: Router,
        private confirmDialogService: ConfirmDialogService,
        private pageTitleService: PageTitleService
    ) {
        super();
        this.user = {} as User;
    }

    showError(control: NgModel, error: string) {
        return control.hasError(error) && (control.dirty || control.touched);
    }

    emailIsInUse() {
        return this.emailInUse && this.user.email === this.emailInUseFor;
    }

    clearEmailInUse(email: string) {
        if (email !== this.emailInUseFor) {
            this.emailInUse = false;
            this.emailInUseFor = null;
        }
    }

    ngOnInit() {
        this.pageTitleService.setTitle('Registreren');
        this.watchRouteParams(this.RouteParamnames.projectId, ({ projectId }) => {
            if (projectId) {
                this.user.customerProjectIds = [+projectId];
            } else {
                this.router.navigate([this.Routenames.login], { replaceUrl: true });
            }
        });
    }

    save(form: NgForm) {
        if (!form.valid) {
            form.form.markAllAsTouched();

            return;
        }

        this.submitDisabled = true;
        this.submitText += '...';

        this.userService
            .registerUser(this.user)
            .then(() => {
                this.emailInUse = false;
                this.emailInUseFor = null;
                this.submitDisabled = false;
                this.submitText = 'Registreren';
                this.router.navigate([this.Routenames.login, this.Routenames.code], {
                    queryParams: { email: this.user.email },
                    replaceUrl: true,
                });
            })
            .catch(error => {
                this.submitDisabled = false;
                this.submitText = 'Registreren';

                if (error['message']['status'] == 409) {
                    this.emailInUse = true;
                    this.emailInUseFor = this.user.email;
                    this.confirmDialogService.confirm(
                        'Email al in gebruik',
                        'Dit email adres is al in gebruik. Log in of gebruik een ander email adres.',
                        'Oke'
                    );
                }
            });
    }
}
